import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './DreamupInfo.scss';
var DreamupInfo = function (_a) {
    var prompt = _a.prompt, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement("p", { className: s['prompt'] },
            React.createElement("span", { className: s['prompt-preface'] },
                t('deviation.details.dreamup.promptPreface'),
                ":"),
            prompt),
        React.createElement("div", { className: s['logo-and-preface'] },
            React.createElement("p", { className: s['logo-preface'] }, t('deviation.details.dreamup.logoPreface')),
            React.createElement(PlainButtonOrLink, { href: Url.dreamupLink() },
                React.createElement(DaDreamupLogoAndText, { className: s['logo'] })))));
};
DreamupInfo.displayName = 'DreamupInfo';
export default DreamupInfo;
//# sourceMappingURL=DreamupInfo.js.map